import homeIcon from "../../images/Icons/home.png";
import candleIcon from "../../images/Icons/candle.png";
import netflixIcon from "../../images/Icons/netflix.png";
import instagramIcon from "../../images/Icons/instagram.png";
import consoleIcon from "../../images/Icons/console.png";
import haircutIcon from "../../images/Icons/haircut.png";
import uberIcon from "../../images/Icons/uber.png";
import boatIcon from "../../images/Icons/boat.png";
import posterIcon from "../../images/Icons/poster.png";
import stimulusCheckIcon from "../../images/Icons/stimulusCheck.png";

const questions = [
  {
    id: 1,
    title: "house",
    desc: "Your parents sold your childhood home this year. (You live in the U.S.)",
    answer: "no",
    icon: homeIcon,
    wrongAnswerText: "Not quite! Your childhood home wasn't created this year, so even if the sale occurred this year, it isn't counted.",
    rightAnswerText: "Great job! This is considered a used good and reselling a used good does not count towards U.S. GDP.",
  },
  {
    id: 2,
    title: "candle",
    desc: "Your friend bought a U.S. made candle at Target this year.",
    answer: "yes",
    icon: candleIcon,
    wrongAnswerText: "Not quite! This counts toward GDP because it's a U.S. good sold this year.",
    rightAnswerText: "You got it—this is a final good made in the U.S. and sold this year, so it definitely counts towards GDP.",
  },
  {
    id: 3,
    title: "gaming console",
    desc: "Your friend bought a gaming console at your local Walmart but the gaming console was manufactured overseas.",
    answer: "no",
    icon: consoleIcon,
    wrongAnswerText: "Not quite! The gaming console was produced overseas, so this will not count towards U.S. GDP. However, technically, a very small portion of the cost of the gaming console will count towards U.S. GDP. Specifically, the markup that Walmart charges in order to provide the service of stocking and selling the console in the U.S. will count towards U.S. GDP.",
    rightAnswerText: "Yes—the gaming console is imported from another country, so this will not count towards U.S. GDP. However, technically, a small portion of the cost of the gaming console will count towards U.S. GDP. Specifically, the markup that Walmart charges in order to provide the service of stocking and selling the console in the U.S. will count towards U.S. GDP.",
  },
  {
    id: 4,
    title: "Uber",
    desc: "Your mom took an Uber.",
    answer: "yes",
    icon: uberIcon,
    wrongAnswerText: "Not quite! This is a U.S. service that your mother paid for, so this counts towards U.S. GDP.",
    rightAnswerText: "Right—an Uber ride is a service provided this year in the U.S., so it counts towards U.S. GDP.",
  },
  {
    id: 5,
    title: "Netflix",
    desc: "You bought a subscription to Netflix this year.",
    answer: "yes",
    icon: netflixIcon,
    wrongAnswerText: "Not quite! This is a U.S. subscription service, so it counts towards U.S. GDP.",
    rightAnswerText: "Yes—Netflix is a U.S. company that provides a service, so it counts towards U.S. GDP.",
  },
  {
    id: 6,
    title: "government spending",
    desc: "Your parents received a stimulus check from the U.S. Federal Government.",
    answer: "no",
    icon: stimulusCheckIcon,
    wrongAnswerText: "Not quite! A stimulus check is a government transfer of funds, not a government purchase of goods or services, so it does not count towards U.S. GDP.",
    rightAnswerText: "Great job! A stimulus check is a government transfer. Only a goverment purchase of goods or services counts towards U.S. GDP.",
  },
  {
    id: 7,
    title: "camp",
    desc: "You pay $1000 for a 1-week adventure camp in Montana.",
    answer: "yes",
    icon: boatIcon,
    wrongAnswerText: "Not quite! U.S. GDP counts all services in the U.S., and an adventure camp is a service.",
    rightAnswerText: "You got it—an adventure camp is a service, so it counts towards U.S. GDP.",
  },
  {
    id: 8,
    title: "haircut",
    desc: "You cut your dad's hair this month because of the pandemic.",
    answer: "no",
    icon: haircutIcon,
    wrongAnswerText: "Not quite! You didn't charge your dad for the haircut, so even though it is a service, it isn't counted towards U.S. GDP. This is a limitation of GDP—it only counts services and goods that are bought and sold. And even if you did charge, there is no way to formally account for this transaction, so it won't count.",
    rightAnswerText: "Right! If your dad would have gotten his haircut at a local barbershop, this would have counted towards U.S. GDP. However, because you cut it, it does not count.",
  },
  {
    id: 9,
    title: "instagram",
    desc: "Your little sister joined Instagram this year.",
    answer: "no",
    icon: instagramIcon,
    wrongAnswerText: "Not quite! Joining instagram is free, so even though your sister might derive value or consumer surplus from the service, it does not affect U.S. GDP.",
    rightAnswerText: "Great job! Because having an account on Instagram is free, it does not affect U.S. GDP.",
  },
  {
    id: 10,
    title: "poster",
    desc: "A Canadian resident bought an art poster created in the U.S.",
    answer: "yes",
    icon: posterIcon,
    wrongAnswerText: "Not quite! A new poster created in the U.S. counts towards U.S. GDP even when the buyer lives abroad.",
    rightAnswerText: "Perfect! Since this poster was made in the U.S., it counts towards U.S. GDP no matter where the buyer.",
  },
];

export default questions;
